/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The trigger instance status.
 */
export const TriggerInstanceStatus = {
  Active: "active",
  Paused: "paused",
  Fired: "fired",
  Cancelled: "cancelled",
} as const;
/**
 * The trigger instance status.
 */
export type TriggerInstanceStatus = OpenEnum<typeof TriggerInstanceStatus>;

export type TriggerInstance = {
  /**
   * The trigger config payload.
   */
  config: { [k: string]: any };
  /**
   * Creation timestamp.
   */
  createdAt: Date;
  /**
   * The trigger definition slug.
   */
  definitionSlug: string;
  /**
   * The linked environment ID.
   */
  environmentId?: string | undefined;
  /**
   * The trigger instance ID.
   */
  id: string;
  /**
   * The trigger instance name.
   */
  name: string;
  /**
   * The project ID owning the trigger instance.
   */
  projectId: string;
  /**
   * The trigger instance status.
   */
  status: TriggerInstanceStatus;
  /**
   * The user-facing target display value.
   */
  targetDisplay: string;
  /**
   * The target kind for the trigger instance.
   */
  targetKind: string;
  /**
   * The opaque target reference.
   */
  targetRef: string;
  /**
   * Last update timestamp.
   */
  updatedAt: Date;
  /**
   * Webhook URL for webhook-backed triggers.
   */
  webhookUrl?: string | undefined;
};

/** @internal */
export const TriggerInstanceStatus$inboundSchema: z.ZodMiniType<
  TriggerInstanceStatus,
  unknown
> = openEnums.inboundSchema(TriggerInstanceStatus);

/** @internal */
export const TriggerInstance$inboundSchema: z.ZodMiniType<
  TriggerInstance,
  unknown
> = z.pipe(
  z.object({
    config: z.record(z.string(), z.any()),
    created_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    definition_slug: z.string(),
    environment_id: z.optional(z.string()),
    id: z.string(),
    name: z.string(),
    project_id: z.string(),
    status: TriggerInstanceStatus$inboundSchema,
    target_display: z.string(),
    target_kind: z.string(),
    target_ref: z.string(),
    updated_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    webhook_url: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "created_at": "createdAt",
      "definition_slug": "definitionSlug",
      "environment_id": "environmentId",
      "project_id": "projectId",
      "target_display": "targetDisplay",
      "target_kind": "targetKind",
      "target_ref": "targetRef",
      "updated_at": "updatedAt",
      "webhook_url": "webhookUrl",
    });
  }),
);

export function triggerInstanceFromJSON(
  jsonString: string,
): SafeParseResult<TriggerInstance, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TriggerInstance$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TriggerInstance' from JSON`,
  );
}
